import React, { useState, useEffect} from "react";
import { Form, Button} from 'semantic-ui-react';
import { useForm } from "react-hook-form";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useNavigate } from "react-router-dom";
import { HTTPURL, REQUEST_OPTIONS } from "../constants/matcher";
import $ from 'jquery';
// import { HttpChild, Child } from "../Utils/HttpChild";
import {useFetchApi} from "../customHooks/useFetch";
import {Helmet} from "react-helmet";

function Survey() {
    const navigate = useNavigate();
    const [reqData, setreqData] = useState({}); // <-- add state
    const { resData } = useFetchApi(reqData); // <-- pass location value to hook

    useEffect( () => {
              
    });

    const {
        register: register2,
        handleSubmit: handleSubmit2,
        formState: { errors: errors2 },
        reset: reset2,
        // watch: watch2,
    } = useForm();

    const onSubmitSurvey = (data) =>
    {
        componentDidMountSurvey(data);
    }

    const componentDidMountSurvey = (requestData) => {
        const user_id = JSON.parse(localStorage.getItem("user-data"));
        requestData.user_id = user_id[0]?.id;
        REQUEST_OPTIONS.method = 'POST';
        REQUEST_OPTIONS.body = JSON.stringify(requestData);

        fetch(HTTPURL+'user/survey', REQUEST_OPTIONS)
        .then(async response => {
            const isJson = response.headers.get('content-type')?.includes('application/json');
            const data = isJson && await response.json();
    
            if (!response.ok) {
                const error = (data && data.message) || response.status;
                return Promise.reject(error);
            }
            if(data.status===true){
                const url_redirect = user_id[0]?.userType == 0 ? '/civil-servant': '/mentor'
                navigate(url_redirect);
                toast.success(data.message)
            }else{
                toast.error(data.message)
            }
        })
        .catch(error => {
            console.error('There was an error!', error);
        });
    }
    return (
        
        <section className="h-100 bg-dark register-page">
            <Helmet>
                <title>Survey page : - TMS</title>
            </Helmet>
            {/* <ToastContainer /> */}
            <div className="container py-5 h-100">
                <div className="row d-flex justify-content-center align-items-center h-100">
                    <div className="col">
                        <div className="card card-registration my-4">
                            <div className="row g-0">
                                <div className="col-xl-6 d-none d-xl-block register-left">
                                    <img src="https://mdbcdn.b-cdn.net/img/Photos/new-templates/bootstrap-registration/img4.webp"
                                        alt="" className="img-fluid"
                                    />
                                </div>
                                
                                <div className="col-xl-6 register-right" id="surveyForm">
                                    <Form onSubmit={handleSubmit2(onSubmitSurvey)}>
                                        <div className="card-body p-md-5 text-black">
                                            <h3 className="mb-5 text-uppercase">Survey form</h3>
                                            <div className="row">
                                                <div className="col-md-6 mb-4">
                                                    <div className="form-outline">
                                                        <div className="d-md-flex justify-content-start align-items-center mb-4 py-2">
                                                            <Form.Field>
                                                                <label className="form-label" htmlFor="form3Example1m">Have you ever attended any similar Training officially?</label>

                                                                <div className="form-check form-check-inline">
                                                                    <input
                                                                        {...register2("similer_training", { required: true })}
                                                                        type="radio"
                                                                        value="1"
                                                                        id="st1"
                                                                        className="form-check-input"
                                                                    />
                                                                    <label className="form-check-label" htmlFor="st1">Yes</label>
                                                                </div>

                                                                <div className="form-check form-check-inline">
                                                                    <input
                                                                        {...register2("similer_training", { required: true })}
                                                                        type="radio"
                                                                        value="0"
                                                                        id="st0"
                                                                        className="form-check-input"
                                                                    />
                                                                    <label className="form-check-label" htmlFor="st0">No</label>
                                                                </div>
                                                            </Form.Field>
                                                        </div>
                                                        {errors2.similer_training && errors2.similer_training.type === "required" && <span className="validation-error">This is required</span>}
                                                    </div>
                                                </div>

                                                <div className="col-md-6 mb-4">
                                                    <div className="form-outline">
                                                        <div className="d-md-flex justify-content-start align-items-center mb-4 py-2">
                                                            <Form.Field>
                                                                <label className="form-label" htmlFor="form3Example1m">Is the chosen course relevant to your official work?</label>

                                                                <div className="form-check form-check-inline">
                                                                    <input
                                                                        {...register2("course_relevant", { required: true })}
                                                                        type="radio"
                                                                        value="1"
                                                                        id="cr1"
                                                                        className="form-check-input"
                                                                    />
                                                                    <label className="form-check-label" htmlFor="cr1">Yes</label>
                                                                </div>

                                                                <div className="form-check form-check-inline">
                                                                    <input
                                                                        {...register2("course_relevant", { required: true })}
                                                                        type="radio"
                                                                        value="0"
                                                                        id="cr0"
                                                                        className="form-check-input"
                                                                    />
                                                                    <label className="form-check-label" htmlFor="cr0">No</label>
                                                                </div>
                                                            </Form.Field>
                                                        </div>
                                                        {errors2.course_relevant && errors2.course_relevant.type === "required" && <span className="validation-error">This is required</span>}
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="row">
                                                <div className="col-md-6 mb-4">
                                                    <div className="form-outline">
                                                        <div className="d-md-flex justify-content-start align-items-center mb-4 py-2">
                                                            <Form.Field>
                                                                <label className="form-label" htmlFor="form3Example1m">Have you attended any training on the chosen course in the past?</label>

                                                                <div className="form-check form-check-inline">
                                                                    <input
                                                                        {...register2("past_training", { required: true })}
                                                                        type="radio"
                                                                        value="1"
                                                                        id="pt1"
                                                                        className="form-check-input"
                                                                    />
                                                                    <label className="form-check-label" htmlFor="pt1">Yes</label>
                                                                </div>

                                                                <div className="form-check form-check-inline">
                                                                    <input
                                                                        {...register2("past_training", { required: true })}
                                                                        type="radio"
                                                                        value="0"
                                                                        id="pt0"
                                                                        className="form-check-input"
                                                                    />
                                                                    <label className="form-check-label" htmlFor="pt0">No</label>
                                                                </div>
                                                            </Form.Field>
                                                        </div>
                                                        {errors2.past_training && errors2.past_training.type === "required" && <span className="validation-error">This is required</span>}
                                                    </div>
                                                </div>

                                                <div className="col-md-6 mb-4">
                                                    <div className="form-outline">
                                                        <div className="d-md-flex justify-content-start align-items-center mb-4 py-2">
                                                            <Form.Field>
                                                                <label className="form-label" htmlFor="form3Example1m">Was the training self-sponsored?</label>

                                                                <div className="form-check form-check-inline">
                                                                    <input
                                                                        {...register2("self_sponsored", { required: true })}
                                                                        type="radio"
                                                                        value="1"
                                                                        id="ss1"
                                                                        className="form-check-input"
                                                                    />
                                                                    <label className="form-check-label" htmlFor="ss1">Yes</label>
                                                                </div>

                                                                <div className="form-check form-check-inline">
                                                                    <input
                                                                        {...register2("self_sponsored", { required: true })}
                                                                        type="radio"
                                                                        value="0"
                                                                        id="ss0"
                                                                        className="form-check-input"
                                                                    />
                                                                    <label className="form-check-label" htmlFor="ss0">No</label>
                                                                </div>
                                                            </Form.Field>
                                                        </div>
                                                        {errors2.self_sponsored && errors2.self_sponsored.type === "required" && <span className="validation-error">This is required</span>}
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="d-flex justify-content-between pt-3">
                                                <div className="d-flex align-items-center">
                                                    <Button type="button" className="btn btn-light btn-lg sap-btn-light" onClick={() => reset2()}>Reset</Button>
                                                    <Button type='submit' className="btn btn-warning btn-lg sap-btn-dark ms-2">Submit</Button>                                                    
                                                </div>
                                            </div>
                                        </div>
                                    </Form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}
export default Survey;